var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.options),function(option){return _c('Radio',{key:option[_vm.valueProp],attrs:{"value":_vm.value,"val":option[_vm.valueProp],"label":option[_vm.labelProp],"error":option.error,"disabled":option.disabled,"required":_vm.required,"name":_vm.name},on:{"input":function($event){return _vm.$emit('input', option[_vm.valueProp])}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }